(function ($, Drupal) {
  Drupal.behaviors.mhdkkNewsList = {
    attach: (context, settings) => {
      function loadNews(elm, page){
        let deferred = new $.Deferred();
        let loading = elm.attr('data-loading');
        let end_of_rows = elm.attr('data-end-of-rows');
        if(loading === '1' || end_of_rows === '1'){
          return;
        }
        let display_id = elm.attr('data-display-id');
        let brand = elm.attr('data-brand-tid');
        let lang = $('html').attr('xml:lang');
        let view_args = lang + '/all';
        if(brand !== ''){
          view_args = lang + '/' + brand;
        }

        elm.attr('data-loading', '1');
        $.ajax({
          url: Drupal.absoluteUrl(Drupal.settings.basePath) + 'views/ajax',
          type: 'post',
          data: {
            view_name: 'news_list',
            view_display_id: display_id,
            page: page,
            view_args: view_args,
          },
          dataType: 'json',
          success: function (response) {
            if (response[1] !== undefined) {
              elm.attr('data-page', page);
              if(response[1].data.length === 0){
                  $.when(elm.attr('data-end-of-rows', '1')).then(deferred.resolve());
              }else{
                $.when(elm.append(response[1].data)).then(deferred.resolve());
              }
            }
          }
        }).always(function(data, textStatus, errorThrown){
          $.when(elm.attr('data-loading', '0')).then(deferred.resolve());
        });

        return deferred.promise();
      }

      function getNewsListBottom(elm){
        let newsListBottom;
        newsListBottom = elm.position().top + elm.outerHeight(true);
        newsListBottom = newsListBottom - ($(elm.find('a.panel').get(0)).outerHeight(true)) * 2;//x2 for loading earlier for more news

        return newsListBottom;
      }

      $(document).ready(function () {
        let $newsList = $('#newsList');
        // let loading_mode = $newsList.attr('data-loading-mode');
        // let page = $newsList.attr('data-page');
        // loadNews($newsList, page);

        // if(loading_mode === 'infinite'){
        //   let newsListBottom = getNewsListBottom($newsList);
        //   $(window).on('scroll', function(){
        //     if($(window).scrollTop() >= newsListBottom){
        //       page = $newsList.attr('data-page');
        //       page = parseInt(page) + 1;
        //       $.when(loadNews($newsList, page)).then(function () {
        //         newsListBottom = getNewsListBottom($newsList);
        //       });
        //     }
        //   });
        // }

        /************************************************ イベント & ニュース */
        $newsList.on('mouseenter', 'a', function () {
            let $self = $(this);
            $self.children('.newsIn').stop().css('background-color', '#f9f9f9');
            $self.find('.hoverImg').stop().fadeIn(350);
            /*
            $self.find('.newsImg').stop(false, true).animate({
              'width': 440,
              'height': 330,
              'top': -15,
              'left': -15
            }, 400, 'easeOutQuart');
            */
            $self.find('.newsImg').css('transform', 'scale(1.1)');
          }
        );
        $newsList.on('mouseleave', 'a', function () {
          let $self = $(this);
          $self.children('.newsIn').stop().css('background-color', '#fff');
          $self.find('.hoverImg').stop().fadeOut(350);
          /*
          $self.find('.newsImg').stop(false, true).animate({
            'width': 410,
            'height': 300,
            'top': 0,
            'left': 0
          }, 400, 'easeOutQuart');
          */
          $self.find('.newsImg').css('transform', 'scale(1)');
        });
        let $window = $(window);
        $window.on('load resize', function () {
          $('#newsList .newsImg').removeAttr('style');
        });

      });
    }
  }
})(jQuery, Drupal);
